var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuggestionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2978 32.9917C33.8664 32.7405 31.2401 31.114 29.8349 28.1734C33.1167 25.1047 34.9834 20.8357 34.9834 16.4668C34.9834 7.4248 27.0991 0 17.4917 0C7.88425 0 0 7.4248 0 16.4668C0 25.5088 7.88425 32.9336 17.4917 32.9336C18.7814 32.9336 20.1667 32.8127 22.078 32.4111C27.1015 35.0805 31.6104 35.0054 33.3259 34.9784C34.0896 34.9689 34.644 35.1068 34.9294 34.3178C35.1225 33.7886 34.8368 33.1773 34.2978 32.9917ZM19.5415 24.7344C19.5415 25.8663 18.6238 26.7842 17.4917 26.7842C16.3596 26.7842 15.4418 25.8663 15.4418 24.7344V16.4668C15.4418 15.3347 16.3596 14.4169 17.4917 14.4169C18.6238 14.4169 19.5415 15.3347 19.5415 16.4668V24.7344ZM17.4917 11.274C16.3596 11.274 15.4418 10.3561 15.4418 9.22411C15.4418 8.092 16.3596 7.17427 17.4917 7.17427C18.6238 7.17427 19.5415 8.092 19.5415 9.22411C19.5415 10.3562 18.6238 11.274 17.4917 11.274Z",
    fill: "url(#paint0_linear_320_1717)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_320_1717",
    x1: 34.9898,
    y1: 0.00000178969,
    x2: -25.0617,
    y2: 66.0109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85DDDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestionIcon);
export default __webpack_public_path__ + "static/media/suggestion-icon.3eda1737b0ce2dd157ce379389d88f81.svg";
export { ForwardRef as ReactComponent };